module.exports = __webpack_public_path__ + "static/media/background.cc64e3f0.svg";